const state = {
  profile: {
    personal: {},
    credentials: {},
    practice: {},
    comments: {},
    editInfo: {},
  }
};

const mutations = {
  SET_DOCTOR_PROFILE(state, payload) {
    state.profile = {
      personal: payload.Personal || {},
      credentials: payload.Credentials || {},
      practice: payload.Practice || {},
      comments: payload.Comments || {},
      editInfo: payload.EditInfo || {},
    };
  },
  UPDATE_PERSONAL_INFO(state, payload) {
    state.profile.personal = {...state.profile.personal, ...payload};
  },
  UPDATE_CREDENTIALS(state, payload) {
    state.profile.credentials = {...state.profile.credentials, ...payload};
  },
  UPDATE_PRACTICE(state, payload) {
    state.practice = {
      ...state.practice,
      ...payload
    };
  },
};

const actions = {
  async fetchDoctorProfile({commit}) {
    try {
      const response = await window.axios.get(`${process.env.VUE_APP_URL}/doctors/me`);
      commit('SET_DOCTOR_PROFILE', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching doctor profile:', error);
      throw error;
    }
  },
  async updatePersonalInfo({commit}, payload) {
    try {
      //TODO: change to userId when fix token
      const url = `${process.env.VUE_APP_URL}/doctors/${sessionStorage.getItem('username')}/${state.profile.editInfo.id}`;
      const config = { headers: { "Content-Type": "application/json" } };
      const response = await window.axios.put(url, payload, config);
      commit('UPDATE_PERSONAL_INFO', payload);
      return response;
    } catch (error) {
      console.error('Error updating personal info:', error);
      throw error;
    }
  }
};

const getters = {
  personal: (state) => state.profile.personal,
  credentials: (state) => state.profile.credentials,
  getPractice: (state) => state.profile.practice,
  fullProfile: (state) => state.profile,
  editInfo: (state) => state.profile.editInfo
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
